import { render, staticRenderFns } from "./BooleanField.vue?vue&type=template&id=51a5c194&scoped=true&"
import script from "./BooleanField.vue?vue&type=script&lang=js&"
export * from "./BooleanField.vue?vue&type=script&lang=js&"
import style0 from "./BooleanField.vue?vue&type=style&index=0&id=51a5c194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a5c194",
  null
  
)

export default component.exports